module.exports = __webpack_public_path__ + "img/portraits_12_V.4d2b2edf.jpg";